module.exports = __webpack_public_path__ + "static/img/02.161190f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/02.png
// module id = Te1A
// module chunks = 1